import {
  RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE,
  RECOMMENDATION_SERVICE_PDP_PRODUCT_OUT_OF_STOCK,
  RECOMMENDATION_SERVICE_PDP_RX_PRODUCT,
  type RecommendationServiceType,
} from '../../../recommendation'

export const productAccessorGetRecommendationServiceId = ({
  isAvailable,
  isRx,
}: {
  isAvailable: boolean
  isRx: boolean
}): RecommendationServiceType => {
  if (isRx) {
    return RECOMMENDATION_SERVICE_PDP_RX_PRODUCT
  }

  if (!isAvailable) {
    return RECOMMENDATION_SERVICE_PDP_PRODUCT_OUT_OF_STOCK
  }

  return RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE
}
